<template>
  <polygon
    :fill="fill"
    :stroke="stroke"
    :stroke-width="strokeWidth"
    points="
      0,16
      13.856,8
      13.856,-8
      0,-16
      -13.856,-8
      -13.856,8
      0,16
    "
  />
</template>

<script>
export default {
  name: 'Hexagon',
  props: {
    // Style
    stroke: {
      type: String,
      default: '#757575'
    },
    fill: {
      type: String,
      default: '#757575'
    },
    strokeWidth: {
      type: Number,
      default: 1
    }
  }
}
</script>

<style>

</style>
